import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Encabezado de sección con icono, título, descripción y acciones opcionales.
 * Estilos globales en scss/dhn/_section-header.scss.
 *
 * <SectionHeader icon="fa-id-badge" title="Perfil" description="Datos generales." />
 */
export default function SectionHeader({
  actions,
  className,
  compact,
  description,
  icon,
  title,
  variant,
}) {
  return (
    <div
      className={classnames("dhn-section-header", className, {
        "is-compact": compact,
      })}
    >
      <div
        className={classnames("dhn-section-header__icon", {
          [`is-${variant}`]: variant !== "primary",
        })}
      >
        <i className={classnames("fa", icon)} aria-hidden="true"></i>
      </div>
      <div className="dhn-section-header__copy">
        <h5>{title}</h5>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="dhn-section-header__actions">{actions}</div>}
    </div>
  );
}

SectionHeader.propTypes = {
  actions: PropTypes.node,
  className: PropTypes.string,
  compact: PropTypes.bool,
  description: PropTypes.node,
  icon: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary", "danger"]),
};

SectionHeader.defaultProps = {
  compact: false,
  variant: "primary",
};

/** Subtítulo en mayúsculas para agrupar campos dentro de una sección. */
export function SectionSubtitle({ children, className }) {
  return (
    <div className={classnames("dhn-section-subtitle", className)}>
      {children}
    </div>
  );
}

SectionSubtitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
